import type { HolisticSummaryCategory } from '@fruitful/types';
import { useLocalSearchParams } from 'expo-router';

import CategoryOverview from '../../../../holistic/components/CategoryOverview';

const HolisticCategoryOverview = () => {
    const { category } = useLocalSearchParams<{
        category: HolisticSummaryCategory;
    }>();

    return <CategoryOverview category={category} />;
};

export default HolisticCategoryOverview;
